import { useEffect, useState } from 'react';

const PHONE = '(max-width: 639px)';

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => typeof window !== 'undefined' && window.matchMedia(query).matches);
  useEffect(() => {
    const list = window.matchMedia(query);
    const apply = () => setMatches(list.matches);
    apply();
    list.addEventListener('change', apply);
    return () => list.removeEventListener('change', apply);
  }, [query]);
  return matches;
}

export function usePhoneLayout(): boolean {
  return useMediaQuery(PHONE);
}
